import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useAxios from 'axios-hooks';
import { useTranslation } from 'react-i18next';
import { history } from '../../App';
import { getAPIUrl, getBaseUrl, isWhiteListedEnvironment } from '../../utility';
import './Splash.scss';

const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    let sortableItems = [...items].map(si => {
      let siUpdate = si;
      if (!siUpdate.lastBuilt) {
        siUpdate.lastBuilt = '';
      }
      return siUpdate;
    });
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = key => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};
const SortableTable = ({ availableCourses, assemblyReports }) => {
  const { items, requestSort, sortConfig } = useSortableData(availableCourses, {
    key: 'lastBuilt',
    direction: 'descending'
  });

  const [showReport, setShowReport] = useState(
    (() => {
      let toggleMap = {};
      availableCourses.forEach(c => ({
        [c.key]: false
      }));
      return toggleMap;
    })()
  );

  const getClassNamesFor = name => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };
  const openCourse = courseKey => {
    history.push(`/${courseKey}`);
  };
  return (
    <table className="table table--bordered table--compressed table--wrap">
      <thead>
        <tr>
          <th>
            <a
              href="#donothing"
              onClick={e => {
                e.preventDefault();
                requestSort('title');
              }}
              className={getClassNamesFor('title')}
            >
              Offering
            </a>
          </th>
          <th>
            <a
              href="#donothing"
              onClick={e => {
                e.preventDefault();
                requestSort('key');
              }}
              className={getClassNamesFor('key')}
            >
              Key
            </a>
          </th>
          <th>
            <a
              href="#donothing"
              onClick={e => {
                e.preventDefault();
                requestSort('status');
              }}
              className={getClassNamesFor('status')}
            >
              Status
            </a>
          </th>
          <th>
            <a
              href="#donothing"
              onClick={e => {
                e.preventDefault();
                requestSort('lastBuilt');
              }}
              className={getClassNamesFor('lastBuilt')}
            >
              Latest Build
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((course, i) => {
          const event = course.lastBuilt ? new Date(course.lastBuilt) : '';

          const options = {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            seconds: 'numeric'
          };
          // if (course.lastBuilt === 'currently assembling') {
          //   console.log(' building now');
          //   event = 'currently assembling';
          // } else {
          //   //
          // }
          // console.log(' item');
          const courseAssemblyReports = assemblyReports
            .filter(r => r.course === course.key)
            .sort(
              (a, b) => new Date(b.assembly_date) - new Date(a.assembly_date)
            );

          return (
            <tr key={i}>
              <td>
                {course.lastBuilt === 'assembling now' ? (
                  `${course.title}`
                ) : (
                  <a
                    href="#course"
                    onClick={e => {
                      e.preventDefault();
                      openCourse(course.key);
                    }}
                  >
                    {course.title}
                  </a>
                )}

                {courseAssemblyReports.length > 0 && (
                  <a
                    href="#course"
                    style={{ float: 'right' }}
                    onClick={e => {
                      e.preventDefault();
                      let showReportToggle = { ...showReport };
                      showReportToggle[course.key] = !showReport[course.key];
                      setShowReport(showReportToggle);
                    }}
                  >
                    Assembly Details
                  </a>
                )}
                <div
                  className={`assembly-reports ${
                    showReport[course.key] ? '' : 'hide'
                  }`}
                >
                  {courseAssemblyReports.map((r, i) => {
                    return (
                      <div key={i} className="build">
                        <h4>
                          {/* {r.assembly_date} */}
                          {new Date(r.assembly_date).toLocaleDateString(
                            'en-US',
                            options
                          )}
                        </h4>
                        {r.buildMessage && (
                          <div>
                            <em className="text-size-14">{r.buildMessage}</em>
                          </div>
                        )}
                        {r.touched_lis && (
                          <div>
                            <strong className="text-size-14">
                              Location Indicators modified in {course.key}:
                            </strong>

                            <div className="text-size-10">
                              {r.touched_lis.join(', ')}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </td>
              <td>{course.key}</td>
              <td>
                <span
                  className={`label label--${
                    course.status === 'production' ? 'success' : 'warning'
                  }`}
                >
                  {course.status}
                </span>
              </td>
              <td>
                {course.lastBuilt === 'assembling now'
                  ? 'assembling now'
                  : event.toLocaleDateString('en-US', options)}
                {
                  //  'asdfasd'
                  // ? event.toLocaleDateString('en-US', options)
                  //: ''}else{"asdfsd"}}
                  // }
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const Splash = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const baseUrl = getBaseUrl();
  const apiUrl = getAPIUrl();

  //Reset the course State so that it grabs the new/updated course data
  dispatch({ type: 'RESET_COURSE' });

  //Call made to get courses.json data from assembled courses
  const [{ data: availableCourses }] = useAxios(`${baseUrl}/courses.json`);
  const [{ data: assemblyReports }] = useAxios(`${apiUrl}/assembly-reports`);

  if (!availableCourses || !assemblyReports) return false;
  return (
    <div className="splash">
      <main className="main-content-wrapper main-content-wrapper-basic">
        <div
          className={`splash-header${
            !isWhiteListedEnvironment() ? ' header-center' : ''
          }`}
        >
          <span className="icon-cisco" aria-label={t('AppHeader.logo')} />
          <h1>Cisco Networking Academy</h1>
        </div>

        {isWhiteListedEnvironment() && availableCourses.length && (
          <>
            <hr />
            <br />
            <h3 style={{ textAlign: 'center' }}>{t('Splash.courseListMsg')}</h3>
            <br />
            <SortableTable
              availableCourses={availableCourses}
              assemblyReports={assemblyReports}
            />
          </>
        )}
      </main>
    </div>
  );
};

export default Splash;
